module.exports = __webpack_public_path__ + "img/banner.79a4a7cc.png";